module.exports = __webpack_public_path__ + "static/media/IMG_1867.37c48462.PNG";